import React, { useState } from 'react';
import styles from './Header.module.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const navItems = [
    { label: 'Услуги', href: '#services' },
    { label: 'О компании', href: '#about' },
    { label: 'Галерея', href: '#gallery' },
    { label: 'Контакты', href: '#contact' },
  ];

  return (
    <header className={styles.header}>
      <div className="container">
        <div className={styles.headerContent}>
          <div className={styles.logo}>
            <a href="/">
              <i className="fas fa-qrcode"></i>
              <span>REGIONCHECK</span>
            </a>
          </div>

          <nav className={`${styles.nav} ${isMenuOpen ? styles.navOpen : ''}`}>
            <ul className={styles.navList}>
              {navItems.map((item, index) => (
                <li key={index} className={styles.navItem}>
                  <a 
                    href={item.href} 
                    className={styles.navLink}
                    onClick={closeMenu}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className={styles.contactInfo}>
            <a href="tel:+79874817932" className={styles.phoneLink}>
              <i className="fas fa-phone-alt"></i>
              <span>+7 (987) 481-79-32</span>
            </a>
          </div>

          <button 
            className={`${styles.menuToggle} ${isMenuOpen ? styles.menuToggleActive : ''}`}
            onClick={toggleMenu}
            aria-label="Меню"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;